import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from './withRouter';
import { DontHavePermission } from '../DontHavePermission/DontHavePermission';
import { isForbiddenError } from '../../services/errorUtils';

class ForbiddenErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasForbiddenError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state to show fallback UI on error
    if (isForbiddenError(error)) {
      return { hasForbiddenError: true };
    }
    return null;
  }

  componentDidUpdate(prevProps) {
    // Reset error state when route changes
    if (prevProps.location?.pathname !== this.props.location?.pathname) {
      if (this.state.hasForbiddenError) {
        this.setState({ hasForbiddenError: false });
      }
    }
  }

  render() {
    if (this.state.hasForbiddenError) {
      return <DontHavePermission headerText={this.props.headerText} showBackButton={true} />;
    }

    return this.props.children;
  }
}

ForbiddenErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  headerText: PropTypes.string,
  location: PropTypes.object
};

export default withRouter(ForbiddenErrorBoundary);
